function EGiftRecipient() {
    this.name = ''
    this.email = ''
    this.confirmEmail = ''
    this.message = ''
    this.carrierFrom = ''
}

export default EGiftRecipient
